<template>
	<section class="p-empty-message tw-flex tw-items-center tw-justify-center">
		<div class="p-empty-message--box tw-text-center">
			<p class="text-uppercase tw-m-0">
				<slot></slot>
			</p>
		</div>
	</section>
</template>

<script>
export default {
	name: 'PEmptyMessage',
};
</script>

<style scoped lang="scss">
.p-empty-message {
	height: 100%;
	min-height: 277px;
	&--box {
		width: 300px;
		padding: 20px;
		border: 2px dashed #afafaf;
		color: #afafaf;
		p {
			color: #afafaf;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-empty-message.vue